import { _range } from '@naturalcycles/js-lib'
import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './HeroRating.module.scss'

interface HeroRatingProps {
  reviews?: string
  layout?:
    | 'small'
    | 'default'
    | 'centered'
    | 'alignLeft'
    | 'alignStarsLeft'
    | 'centeredOnTwoLines'
    | 'alignStarsRight'
  customScoreSize?: 'default' | 'medium'
  textAlignLeft?: boolean
  textColor?: 'black' | 'white'
  starCustomColor?: string
  appDistributor?: 'App Store' | 'Google Play'
  className?: string
}

export function HeroRating({
  reviews = '',
  customScoreSize = 'default',
  layout = 'default',
  textColor = 'black',
  appDistributor = 'App Store',
  starCustomColor,
  textAlignLeft,
  className = '',
}: HeroRatingProps): ReactNode {
  const defaultText =
    appDistributor === 'App Store' ? '57,7K+ App Store ratings' : '18K Google Play ratings'
  const stars = appDistributor === 'App Store' ? '4.8' : '4.6'

  const small = layout === 'small'
  const centered = layout === 'centered'

  const ratingClass = classNames(styles.HeroRating__ratingScore, {
    [styles.HeroRating__ratingScore___small]: small,
    [styles.HeroRating__ratingScore___medium]: customScoreSize === 'medium',
  })

  const ratingTextClass = classNames(styles.HeroRating__ratingText, {
    [styles.HeroRating__ratingText___small]: small,
    [styles.HeroRating__ratingText___alignLeft]: textAlignLeft,
  })

  return (
    <div
      className={`${styles.HeroRating} ${styles[`HeroRating___${layout}`]} ${
        styles[`HeroRating___${textColor}`]
      }`}
    >
      <p className={ratingClass}>{stars}</p>
      <svg
        className={classNames(styles.HeroRating__ratingStars, className)}
        style={centered ? { width: '80px', justifySelf: 'center' } : {}}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 180 30"
        aria-label="5 stars"
      >
        <defs>
          <path
            id="star"
            fill={starCustomColor || ''}
            d="M14.3 0l3.3 10h10.7l-8.7 6.2 3.3 10-8.6-6.2-8.7 6.2 3.3-10L.2 10H11l3.3-10z"
          />
        </defs>
        {_range(5).map(n => (
          <use key={n} x={n * 37} y={0} xlinkHref="#star" />
        ))}
      </svg>
      <p className={ratingTextClass}>{reviews || defaultText}</p>
    </div>
  )
}
